import { createAsyncThunk } from "@reduxjs/toolkit";
import {environment} from "environments/environment";
import {ProductInterface} from "../../../interfaces/product/product.interface";
import {RootState} from "../product.store";

const isProductInWishlist = (productId: number, wishlistKey = "_wishlist") => {
    const wishlist = localStorage.getItem(wishlistKey);

    if (!wishlist) {
        return false;
    }

    const wishlistArray = wishlist.includes(",")
        ? wishlist.split(",")
        : [wishlist];

    return wishlistArray.includes(String(productId));
};

export const initProduct = createAsyncThunk<
    ProductInterface,
    void,
    { state: RootState }
>(
    "product/initProduct",
    async (_, { getState }) => {
        let product = getState().product.product;

        if (product.needUpdate) {
            const response = await fetch(
                environment.urls.product.fetchProduct,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        productId: product.id,
                    }),
                }
            );

            if (!response.ok) {
                throw new Error("Failed to fetch product");
            }

            const data: Partial<ProductInterface> = await response.json();

            product = {
                ...product,
                ...data,
            };
        }

        return {
            ...product,
            isWishlist: isProductInWishlist(product.id),
        };
    }
);